export default __webpack_public_path__ + "static/media/11.0fb148b8.jpg";